module.exports = "/_next/static/images/scheduleLoader-57a8de69696b7f7fb2984f520eb43613.gif";